import {
  CreateClaimResponse,
  IClaimMultiSignWallet,
  ICreateClaimMultiSignWallet,
  PendingSafesResponse,
  SingleClaimResponse,
  SingleWalletResponse,
  StxChain,
} from 'types/api/ApiResponseTypes';

import { STXAxiosInstance } from '../Axios/STXAxiosInstance';

export const createMultisignWallet = async (item: ICreateClaimMultiSignWallet) =>
  STXAxiosInstance.post<SingleWalletResponse>('/pending-multi-sigs', { ...item }).then(
    (data) => data.data
  );

export const getPendingMultisigs = async (network: StxChain) =>
  STXAxiosInstance.get<PendingSafesResponse>(`/pending-multi-sigs?chain=${network}`, {}).then(
    (data) => {
      return data.data.data.filter((item) => item.status === 'QUEUED');
    }
  );

export const getArchivedMultisigs = async (network: StxChain): Promise<IClaimMultiSignWallet[]> =>
  STXAxiosInstance.get<PendingSafesResponse>(`/multi-sigs/archived/`, {}).then((data) => {
    return data.data.data;
  });

export const acceptInviteMultisigRequest = async (inviteCode: string, chain: StxChain) =>
  STXAxiosInstance.put<CreateClaimResponse>('/pending-multi-sigs', {
    inviteCode,
    chain,
  }).then((data) => data.data);

export const getMyMultisignClaimById = async (inviteCde: string) =>
  STXAxiosInstance.get<SingleClaimResponse>(`/pending-multi-sigs/by-id/${inviteCde}`, {}).then(
    (data) => data.data
  );

export const getAllMyMultisigs = async (network: StxChain): Promise<IClaimMultiSignWallet[]> =>
  STXAxiosInstance.get(`/multi-sigs?chain=${network}`, {}).then((data) => {
    return data.data.data;
  });

export const getMultisignWalletById = async (id: string) =>
  STXAxiosInstance.get<SingleWalletResponse>(`/multi-sigs/${id}`, {}).then((data) => data.data);

export const removeInviteMultisigRequest = async (id: string) =>
  STXAxiosInstance.delete<void>(`/pending-multi-sigs/${id}`, {}).then((data) => data.data);

export const createSubaccount = async (safeId: string, name: string) =>
  STXAxiosInstance.post<SingleWalletResponse>('multi-sigs/' + safeId + '/subaccount', {
    name,
  }).then((data) => data.data);

export const getMultisignWalletByAddress = async (address: string, network: StxChain) =>
  STXAxiosInstance.get<SingleWalletResponse>(
    `/multi-sigs/by-address/${network}/${address}`,
    {}
  ).then((data) => data.data);

export const updateSafePrivacyMode = async (safeId: string, value: boolean) =>
  STXAxiosInstance.get(`multi-sigs/flag/${safeId}/${value}`).then((data) => data.data);
